import { useReviewContext } from "./ReviewContextProvider"
import { TreeNodeAny } from "./tree/path-tree"

const useHasInboxItems = () => {
  const {
    selectedParent,
    actions: { getItem }
  } = useReviewContext()

  // TODO: figure out a workaround for this, this is to make sure the item is
  // actually up-to-date w/ any changes to the item in the context store
  const parentItem = getItem(selectedParent?.id || "") as TreeNodeAny | null

  const childItems =
    parentItem && parentItem.children ? [...parentItem.children.values()] : []

  const hasItems = childItems.length > 0

  return hasItems
}

export default useHasInboxItems
